import { css } from '@emotion/react'

const content = css`
  & > *:not(:last-child) {
    margin-bottom: 24px;
  }
`

const dropdownContainer = css`
  & > * {
    width: 100%;
  }
`

const dropdownBtn = css`
  min-width: 100%;
  width: 100%;
`

export const styles = {
  content,
  dropdownContainer,
  dropdownBtn,
}
